import React, { Component } from "react";
import { Route, Switch, Router } from "react-router-dom";
import "./App.scss";
import './globalFonts.css';
import { createBrowserHistory } from "history";

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);
const hist = createBrowserHistory();

// Containers
const DefaultLayout = React.lazy(() =>
  import("./containers/DefaultLayout/DefaultLayout")
);

const OtpUI = React.lazy(() => import("./views/Pages/Login/otpContainer"));
const Login = React.lazy(() => import("./views/Pages/Login/Login"));

const LoginMaintainance = React.lazy(() =>
  import("./views/Pages/Login/LoginMaintainance")
);


const Page404 = React.lazy(() => import("./views/Pages/Page404/Page404"));
const Page500 = React.lazy(() => import("./views/Pages/Page500/Page500"));
const Download = React.lazy(() => import("./containers/Download/Download"));
const ESign_error = React.lazy(() =>
  import("./containers/Download/ESignError")
);
const ConsenteSignResp = React.lazy(() =>
  import("./containers/Consent/ConsentResponse")
);
const ConsenteSign = React.lazy(() =>
  import("./containers/Consent/ConsenteSign")
);
const NewLandingPage = React.lazy(() =>
  import("./containers/NewLandingPage/NewLandingPage")
);
const MultiPplSignHomePage = React.lazy(() =>
  import("./containers/MultiPplSign/NewMultiPplSignHomePage")
);
// const TandC = React.lazy(() => import("./views/Pages/Register/TandC"));
const TandC = React.lazy(() =>
  import("./views/Pages/Register/TermsAndConditions")
);
const PrivacyPolicy = React.lazy(() =>
  import("./views/Pages/Register/PrivacyPolicy")
);
const KYCStatusResponse = React.lazy(() =>
  import("./containers/DigiLocker/KYCStatusResponse")
);

const MultiPplSignMobilePage = React.lazy(() =>
  import("./containers/MultiPplSign/NewMultiPplSignMobilePage")
);

class App extends Component {
  render() {
    // Maintenance switch (public/Constants.js). When true, /login and
    // /maintainence/login swap: public sees the maintenance page on /login,
    // the real login stays reachable at /maintainence/login.
    const isMaintenance =
      window.APP_CONFIG?.is_Maintainece === true ||
      window.APP_CONFIG?.is_Maintainece === "true";

    return (
      <Router history={hist}>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route
              exact
              path={"/login"}
              name="Login Page"
              render={(props) =>
                isMaintenance ? (
                  <LoginMaintainance {...props} />
                ) : (
                  <Login {...props} />
                )
              }
            />

            <Route
              exact
              path={"/maintainence/login"}
              name="Login Page"
              render={(props) =>
                isMaintenance ? (
                  <Login {...props} />
                ) : (
                  <LoginMaintainance {...props} />
                )
              }
            />


            <Route
              exact
              path="/register"
              name="OtpUI"
              render={(props) => <OtpUI {...props} />}
            />

            <Route
              exact
              path="/loginMaintainance"
              name="Login Page"
              render={(props) => <LoginMaintainance {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={(props) => <Page500 {...props} />}
            />
            <Route
              exact
              path="/download"
              name="Signed Doc"
              render={(props) => <Download {...props} />}
            />
            <Route
              exact
              path="/esign_error"
              name="ESign Error"
              render={(props) => <ESign_error {...props} />}
            />
            <Route
              exact
              path="/consenteSignRsep"
              name="Consent eSign Response"
              render={(props) => <ConsenteSignResp {...props} />}
            />
            <Route
              exact
              path="/consenteSign"
              name="Consent eSign NSDL Page"
              render={(props) => <ConsenteSign {...props} />}
            />

            <Route
              exact
              path="/home"
              name="New Landing Page"
              render={(props) => <NewLandingPage {...props} />}
            />
            <Route
              exact
              path="/jsGuest"
              name="Multi Ppl Sign Guest"
              render={(props) => <MultiPplSignHomePage {...props} />}
            />

            <Route
              path="/termsandconditions"
              name="Terms and Condition"
              render={(props) => <TandC {...props} />}
            />
            <Route
              path="/privacypolicy"
              name="Privacy Policy"
              render={(props) => <PrivacyPolicy {...props} />}
            />
            <Route
              exact
              path="/KYCStatusResponse"
              name="KYCStatusResponse"
              render={(props) => <KYCStatusResponse {...props} />}
            />
            <Route
              exact
              path="/deGuest"
              name="Multi Ppl Sign Guest"
              render={(props) => <MultiPplSignMobilePage {...props} />}
            />

            <Route
              path="/"
              name="Home"
              render={(props) => <DefaultLayout {...props} />}
            />


          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}

export default App;
